import React, { useCallback, useState } from "react";

import { Checkbox, TextField } from "@mui/material";
import { formatByText } from "utils";
import * as Styled from "./styles";
import { CatalogProductsProps } from "store/modules/Catalog/types.store";

type ProductCardProps = {
  product: CatalogProductsProps;
  onUpdate: (productId: string, productPrice: number) => void;
  edit?: boolean;
  hasDefinedPrice?: number;
};

const formatCurrency = (valueInCents: number): string => {
  const valueInReais = valueInCents / 100;
  return valueInReais.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
};

const ProductCard = ({
  product,
  onUpdate,
  edit = false,
  hasDefinedPrice = 0,
}: ProductCardProps) => {
  const [checked, setChecked] = useState(false);
  const [priceInCents, setPriceInCents] = useState(0);

  const handleChangeChecked = () => {
    setChecked(!checked);
  };

  const handleUpdate = useCallback(
    (productId: string, productPrice: number) => {
      onUpdate(productId, productPrice);
    },
    [onUpdate],
  );

  const handleChangePrice = (e: React.ChangeEvent<HTMLInputElement>) => {
    const onlyDigits = e.target.value.replace(/\D/g, "");
    const newPriceInCents = Number(onlyDigits);
    setPriceInCents(newPriceInCents);

    const priceInReais = newPriceInCents / 100;
    handleUpdate(product?.id, priceInReais);
  };

  const displayPrice = hasDefinedPrice
    ? formatCurrency(hasDefinedPrice * 100)
    : formatCurrency(priceInCents);

  return (
    <Styled.Container>
      <Styled.ProductInfo>
        {edit && (
          <Checkbox
            color="primary"
            size="small"
            checked={checked}
            onChange={handleChangeChecked}
          />
        )}
        <Styled.ProductImage src={product?.imageUrl} alt={product?.name} />
        <Styled.ProductName>
          {formatByText.formatProductNameAndDescription(
            product?.name,
            product?.description,
          )}
        </Styled.ProductName>
      </Styled.ProductInfo>
      <TextField
        disabled={!checked}
        error={undefined}
        name={product?.name}
        size="small"
        label="Preço"
        value={displayPrice}
        inputProps={{ maxLength: 20, inputMode: "numeric" }}
        onChange={handleChangePrice}
      />
    </Styled.Container>
  );
};

export default ProductCard;
